import React, {useEffect} from 'react'
import AppContainer from "../../components/container/AppContainer";
import {MainTitleContainer, Margin25, Margin50} from "../../styles/GlobalStyles"
import Section from "../../components/container/Section";
import Text from "../../components/text/Text";
import Colors from "../../styles/Colors";
import AnimalCard from "../../components/card/AnimalCard";
import Nathan from "../../assets/images/Nathan.jpg"
import Nathalie from "../../assets/images/Nathalie.jpg";
import {GAPageView} from "../../services/AnalyticsService";

const About = () => {
    useEffect(() => {
        GAPageView("About")
    }, []);

    return (
        <AppContainer>
            <Margin50 />

            <MainTitleContainer>
                <Text
                    type={"h4"}
                    color={Colors.green}
                >
                    Qui sommes nous ?
                </Text>
            </MainTitleContainer>

            <Margin25 />

            <Section marginVertical={25}>
                <AnimalCard
                    imageSrc={Nathalie}
                    imageRight
                >
                    Nathalie FRETZ, j’ai 23 ans. Je suis originaire de Nambsheim dans le Haut-Rhin. Je prépare un
                    diplôme d’ingénieur en alternance, spécialisation en agriculture, environnement et gestion des
                    ressources.
                </AnimalCard>
            </Section>

            <Section marginVertical={25}>
                <AnimalCard imageSrc={Nathan}>
                    Nathan Fricker, j’ai également 23 ans, je suis originaire de Balgau dans le Haut-Rhin et je suis
                    particulièrement attaché à mon terroir. J’ai 2 Brevets de Technicien Supérieur dans le domaine de
                    l’environnement ainsi qu’une licence en Conseiller forestier.
                </AnimalCard>
            </Section>
        </AppContainer>
    )
}

export default About

